// Angular + external
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
// BFX
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { BfxBlotterOrdersContextMenuService } from "./bfx-blotter-orders-contextmenu.service";
import {
  GoldenLayoutService,
  GLPopoutConfiguration,
  GLPopoutState,
  GLPopoutUndockBehaviour,
} from "../golden-layout/golden-layout-service";
import { DashboardItemType } from "../bfx-common/models/dashboard-item-type.enum";

import { GoldenLayoutAdditionMode } from "../golden-layout/golden-layout-addition-mode";
import { BfxConfigService } from "../../shared/auth-services/system-config/bfx-config.service";
import { BfxDialogData } from "../bfx-dialogs/models/bfx-dialog-data.model";
import { BfxDialogCommand } from "../bfx-dialogs/models/bfx-dialog-command.enum";
import { BfxOrderCancelComponentLauncher } from "../bfx-order-cancel/bfx-order-cancel.launcher";
import {
  BfxOrderPauseResumeComponentLauncher,
  OrderPauseResumeInstruction,
} from "../bfx-order-pauseresume/bfx-order-pauseresume.launcher";

import {
  BfxBaseBlotterActionService,
  ActionListener,
} from "../bfx-base-blotter/bfx-base-blotter-action.service";
import { BfxBlotterActionEvent } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBlotterOrdersService } from "../bfx-blotter-orders/bfx-blotter-orders.service";
import { BfxVwapOrdersService } from "../bfx-vwap/bfx-vwap-orders.service";

import {
  TraderGroupPromiseLookupService,
  OrderDataActionPromiseService,
  BfxBlotterOrdersContextMenuItemAcceptanceState,
  BfxBlotterOrdersContextMenuItemQuickFillState,
  BfxBlotterOrdersContextMenuItemUnlockState,
  SystemConfigPromiseService,
  OrdersTableDefinitionFactory,
  TableDefinition,
  ActiveUser,
  SysFeatures,
  COLUMN_TARGET_DESK_ID,
  COLUMN_XFER_TARGET_GROUP,
  BfxBlotterOrdersContextMenuItemDetailFillState,
  FillTolerancePromiseService,
  BfxBlotterOrdersContextMenuItemRejectState,
  TraderGroupLookupService,
  NotificationService,
  OrderSalesApprovalRequestPromiseService,
  CurrencyPairCalendarLookupService,
  OrderDataLookupService,
  OrderAcceptancePromiseService,
  OrderXferPromiseService,
  BfxBlotterAction,
  BFXNotificationSubType,
  BFXNotificationType,
} from "shared/cubiq-services";

//
import { Subject } from "rxjs";
import { UserType } from "shared/cubiq-model-multi-asset/model/enum/UserType";

import { BfxAppStatusService } from "../bfx-common/services/bfx-app-status.service";
import { BfxOrderDialogsProcessorService } from "../bfx-dialogs/services/bfx-order-dialogs-processor.service";
/// order -entry

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OENOperationMode } from "../order-entry/data/enums/oe-operation-mode.enum";
import { OEApiService } from "../order-entry/services/oe-api.service";
import { BfxColDef } from "shared/cubiq-services/model/TableDefinition";
import { LimitOrder } from "shared/cubiq-services/model/orders/LimitOrder";
import { OrderStateRenderer } from "shared/cubiq-services/model/orders/OrderStateRenderer";
import { OrdersTableMode } from "shared/cubiq-services/model/OrdersTableMode";
import { BmarkOrderData } from "shared/cubiq-services/model/benchmarks/BmarkOrderData.model";
import { BfxConfigIDRefHelper } from "../../shared/helper-services/bfx-config-id-ref-helper";
import { ValueDateHelper } from "shared/cubiq-services/model/orders/ValueDateHelper";

import { GammaUtils } from "./GammaUtils";
import { BfxErrorHandlingService } from "app/bfx-common/services/bfx-error-handling.service";
import { BFXDialogIntent } from "app/bfx-dialogs/models/bfx-dialog-intent.enum";
import { BfxFillWarningService } from "../bfx-common/services/bfx-fill-warning.service";
import { DETAILS_MIN_SIZE } from "shared/cubiq-services/model/golden-layout.constants";

@Injectable()
export class BfxBlotterOrdersActionService extends BfxBaseBlotterActionService<CubiqTS.OrderDataImpl> {
  /**********************************************************************/
  /* OBSERVABLE */
  // Observable string sources
  private orderActionDialogSource = new Subject<BfxDialogData>();
  // Observable string streams
  public dialogCtrl$ = this.orderActionDialogSource.asObservable();

  private tableDefinition: TableDefinition = null;
  private cancelWarningThreshold: number = 0;
  private fillWarningThreshold: number = 0;
  private orderStateRenderer: OrderStateRenderer;
  private statePaused: string;
  private valueDateHelper: ValueDateHelper;
  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(
    contextMenuService: BfxBlotterOrdersContextMenuService,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    configService: BfxConfigService,
    private orderAcceptanceService: OrderAcceptancePromiseService,
    private orderXferService: OrderXferPromiseService,
    private traderGroupService: TraderGroupPromiseLookupService,
    private blotterOrdersService: BfxBlotterOrdersService,
    private sysConfigService: SystemConfigPromiseService,
    private vwapService: BfxVwapOrdersService,
    private ordersTableDefinitionFactory: OrdersTableDefinitionFactory,
    private orderDataActionService: OrderDataActionPromiseService,
    private apiService: OEApiService,
    private _appStatusService: BfxAppStatusService,
    private fillToleranceService: FillTolerancePromiseService,
    private _orderDialogProcessorService: BfxOrderDialogsProcessorService,
    protected myTraderGroupLookup: TraderGroupLookupService,
    private notifService: NotificationService,
    private salesApprovalPromiseService: OrderSalesApprovalRequestPromiseService,
    currencyPairCalendarLookupService: CurrencyPairCalendarLookupService,
    private orderDataLookup: OrderDataLookupService,
    private errorsHandler: BfxErrorHandlingService,
    private fillWarningService: BfxFillWarningService,
  ) {
    super(contextMenuService, layoutService, translationService, configService);
    this.orderStateRenderer = new OrderStateRenderer(this.translationService);
    this.statePaused = this.translationService.instant("order.state.PAUSED");
    this.valueDateHelper = new ValueDateHelper(currencyPairCalendarLookupService);
    this.initializeConfig();
    // this.registerSystemControl();
  }

  protected initializeConfig(): void {
    this.tableDefinition = this.ordersTableDefinitionFactory.createDef();

    this.sysConfigService
      .getSystemConfig(SysFeatures.cancelWarningThreshold)
      .then((value: string) => {
        if (value != null) {
          try {
            this.cancelWarningThreshold = parseInt(value);
          } catch (ex) {
            logger.out.warn(
              "Invalid value for system config " +
                SysFeatures[SysFeatures.cancelWarningThreshold] +
                ": " +
                value,
            );
          }
        }
      });

    this.sysConfigService
      .getSystemConfig(SysFeatures.fillWarningThreshold)
      .then((value: string) => {
        if (value != null) {
          try {
            this.fillWarningThreshold = parseInt(value);
          } catch (ex) {
            logger.out.warn(
              "Invalid value for system config " +
                SysFeatures[SysFeatures.fillWarningThreshold] +
                ": " +
                value,
            );
          }
        }
      });
  }

  protected getAuditType(): DashboardItemType {
    return DashboardItemType.OrderBlotterAudit;
  }

  /**
   * Launches a new dialog with a given dialog data
   * @param data the dialog data
   */
  public launchNewDialog(data: BfxDialogData): void {
    this.orderActionDialogSource.next(data);
  }

  @ActionListener(BfxBlotterAction.ACTION_EXPORT)
  public onExport(event: BfxBlotterActionEvent) {
    // return super.onExport(event);
    this.orderActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_CSV_EXPORT_OPEN, null, event, {
        blotterName: "OrderBlotter",
      }),
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_EXPORT_IMPORT)
  public onExportImport(event: BfxBlotterActionEvent) {
    // return super.onExport(event);
    this.orderActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_CSV_EXPORT_OPEN, null, event, {
        blotterName: "OrderBlotter",
        exportForImport: true,
      }),
    );
  }

  /**********************************************************************/
  /* ACTION HANDLERS */

  /*****************************/
  /* QUICK FILL */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_QUICKFILL)
  public onQuickFill(_event: BfxBlotterActionEvent) {
    let quickFillItemState = _event.itemState as BfxBlotterOrdersContextMenuItemQuickFillState;
    let warnings = this.checkFillWarning(
      _event.selectedIds,
      _event.selectedItems,
      quickFillItemState.warnings,
    );

    if (warnings) {
      if (warnings.transfer.display) warnings.warning_count++;

      if (warnings.expired.display) warnings.warning_count++;

      if (warnings.external.display) warnings.warning_count++;

      if (warnings.credit_check.display) warnings.warning_count++;

      if (warnings.fill.display) warnings.warning_count++;

      if (warnings.show) {
        // show quick fill warnings dialog
        warnings["callback"] = this.doPostQuickFillWarning.bind(this, _event);
        this.orderActionDialogSource.next(
          new BfxDialogData(
            BfxDialogCommand.DIALOG_ORDER_QUICK_FILL_WARNING_OPEN,
            null,
            _event,
            warnings,
          ),
        );
      } else {
        // show quick fill confirm dialog
        this.doPostQuickFillWarning(_event);
      }
    } else {
      logger.out.error(
        "ERROR: BfxBlotterOrdersActionService.onQuickFill(): error message: Warnings array is null or undefined!",
      );
    }
  }

  private doPostQuickFillWarning(_event: BfxBlotterActionEvent): void {
    this.fillToleranceService
      .checkQuickFillTolerance(_event.selectedItems)
      .then(async (response) => {
        const tenorAdjustedMessages = await this.fillWarningService.buildTenorAdjustedMessages(
          _event.selectedItems,
        );

        if (response.failedIds.length == 0 && tenorAdjustedMessages.length == 0) {
          this.doQuickFillConfirm(_event);
        } else {
          this.doToleranceWarning(response, tenorAdjustedMessages, _event);
        }
      });
  }

  doQuickFillConfirm(_event: BfxBlotterActionEvent) {
    let payload = {
      callback: this.doPostQuickFillConfirm.bind(this),
    };
    this.orderActionDialogSource.next(
      new BfxDialogData(
        BfxDialogCommand.DIALOG_ORDER_QUICK_FILL_CONFIRM_OPEN,
        null,
        _event,
        payload,
      ),
    );
  }

  /**
   *  Callback from DIALOG_ORDER_QUICK_FILL_CONFIRM_OPEN confirmation Dialog
   */
  private doPostQuickFillConfirm(_event: BfxBlotterActionEvent, stp: boolean): void {
    this.doPostToleranceWarning(_event, stp);
  }

  doToleranceWarning(
    response: any,
    tenorAdjustedMessages: string[],
    _event: BfxBlotterActionEvent,
  ) {
    let payload;
    let messages: string[];

    if (response.failedIds.length == 0) {
      messages = [...tenorAdjustedMessages];
    } else if (response.failedIds.length == 1) {
      messages = [response.failedIds[0].error, ...tenorAdjustedMessages];
    } else {
      messages = [
        this.translationService.instant("tolerance.warning.multiple.message.1", [
          response.failedIds.length,
        ]),
        ...tenorAdjustedMessages,
        this.translationService.instant("tolerance.warning.multiple.message.2", [
          response.origRequest.length,
        ]),
        this.fillWarningService.addOrderRefs(response.origRequest),
      ];
    }
    payload = {
      title: "tolerance.warning.title",
      messages: messages,
      callback: this.doPostToleranceWarning.bind(this),
      isQuickFill: true,
    };
    this.orderActionDialogSource.next(
      new BfxDialogData(
        BfxDialogCommand.DIALOG_ORDER_FILL_TOLERANCE_WARNING_OPEN,
        null,
        _event,
        payload,
      ),
    );
  }

  /**
   *  Callback from DIALOG_ORDER_FILL_TOLERANCE_WARNING_OPEN confirmation Dialog
   */
  private doPostToleranceWarning(_event: BfxBlotterActionEvent, stp: boolean): void {
    let gammaRungs: Map<string, CubiqTS.OrderDataImpl[]> = GammaUtils.extractGammaRungs(
      _event.selectedItems,
    );
    let badRungs: Map<string, CubiqTS.OrderDataImpl> = null;
    if (null != gammaRungs && gammaRungs.size > 0) {
      badRungs = GammaUtils.getBadGammaQuickFillRungs(gammaRungs);
    }
    if (badRungs != null && badRungs.size > 0) {
      let badRungOrderIds: string[] = [];
      badRungs.forEach((rung) => {
        badRungOrderIds.push(rung.orderId.toString());
      });
      this.quickFillTheRest(_event.selectedIds, badRungOrderIds, stp);

      this.doBadGammaQuickFillNotification(_event.selectedIds, badRungOrderIds, badRungs);
    } else {
      this.doQuickFill(_event.selectedIds, stp);
    }
  }

  quickFillTheRest(orderIds: Array<string>, exclusions: Array<string>, stp: boolean) {
    let theRest = orderIds.filter((orderId) => !exclusions.includes(orderId));
    this.doQuickFill(theRest, stp);
  }

  /**
   * Put up a confirmation dialog to tell em what is wrong
   * on Confirm - we want to reroute them to Detail Fill
   */
  private doBadGammaQuickFillNotification(
    selectedOrderIds: string[],
    orderIds: string[],
    orders: Map<string, CubiqTS.OrderDataImpl>,
  ) {
    let notifMessages: string[] = [];
    for (const [key, order] of orders.entries()) {
      if (selectedOrderIds.includes(key.toString())) {
        let allRungs: CubiqTS.OrderDataImpl[] = GammaUtils.getAllRungs(order);
        let midRung: CubiqTS.OrderData = GammaUtils.getMidRungOfGamma(allRungs);
        let midRungId: CubiqTS.Long = null == midRung ? null : midRung.gammaRungId;
        let notifMessage: string = this.translationService.instant("gamma.fail.fill.not.adjacent", [
          order.gammaRungId,
          null == midRungId ? "No Mid" : midRungId,
        ]);
        notifMessages.push(notifMessage);
      }
    }

    let payload = {
      title: "Error Filling Orders",
      callback: this.doPostBadGammaQuickFillNotification.bind(this, orderIds, orders),
      messages: notifMessages,
    };

    this.orderActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_OK, null, null, payload),
    );
  }

  /**
   *  Callback from DIALOG_QUICKFILL_TO_DETAILFILL_GAMMA confirmation Dialog
   */
  doPostBadGammaQuickFillNotification(
    selectedIds: string[],
    selectedItems: Map<string, CubiqTS.OrderDataImpl>,
  ): void {
    // TODO: need to pass the "bad" rungs
    this.doDetailFill(selectedIds, [...selectedItems.values()], []);
  }

  private doQuickFill(selectedIds: Array<string>, stp: boolean): void {
    this._orderDialogProcessorService.executeQuickFill(selectedIds, stp);
  }

  /* Detail FILL */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_DETAILFILL)
  public onDetailFill(_event: BfxBlotterActionEvent) {
    let detailFillItemState = _event.itemState as BfxBlotterOrdersContextMenuItemDetailFillState;

    let badRungs: Map<string, CubiqTS.OrderDataImpl> = null;
    let gammaRungs: Map<string, CubiqTS.OrderDataImpl[]> = GammaUtils.extractGammaRungs(
      _event.selectedItems,
    );
    if (null != gammaRungs && gammaRungs.size > 0) {
      badRungs = GammaUtils.getBadGammaQuickFillRungs(gammaRungs);
    }
    if (badRungs != null && badRungs.size > 0) {
      let allTheIds: Set<string> = new Set<string>(_event.selectedIds);
      let allTheItems: Set<CubiqTS.OrderData> = new Set<CubiqTS.OrderData>(_event.selectedItems);

      _event.selectedIds.forEach((id) => allTheIds.add(id.toString()));

      badRungs.forEach((rung) => {
        let strRungOrderId = rung.orderId.toString();
        if (!allTheIds.has(strRungOrderId)) {
          allTheItems.add(rung);
          allTheIds.add(strRungOrderId);
        }
      });

      this.doDetailFill([...allTheIds], [...allTheItems], detailFillItemState.warnings);
    } else {
      this.doDetailFill(_event.selectedIds, _event.selectedItems, detailFillItemState.warnings);
    }
  }

  doDetailFill(selectedIds: string[], selectedItems: any[], eventWarnings: object) {
    let warnings = this.checkFillWarning(selectedIds, selectedItems, eventWarnings);

    if (warnings) {
      //logger.out.info("A-OMS: Detail fill dialogs! warnings: ", warnings);
      if (warnings.show) {
        if (warnings.transfer.display) warnings.warning_count++;
        if (warnings.expired.display) warnings.warning_count++;
        if (warnings.external.display) warnings.warning_count++;
        if (warnings.credit_check.display) warnings.warning_count++;
        if (warnings.fill.display) warnings.warning_count++;

        this.doDetailFillWarn(warnings, selectedIds, selectedItems);
      } else {
        // show detail fill confirm dialog
        this.doDetailFillConfirm(selectedIds, selectedItems);
      }
    } else {
      logger.out.error(
        "ERROR: BfxBlotterOrdersActionService.onDetailFill(): error message: Warnings array is null or undefined!",
      );
    }
  }

  doDetailFillWarn(warnings: any, selectedIds: string[], selectedItems: any[]) {
    warnings.callback = this.doPostDetailFillWarn.bind(this, selectedIds, selectedItems);

    let event = {
      selectedIds: selectedIds,
      selectedItems: selectedItems,
    };

    // show detail fill warnings dialog
    this.orderActionDialogSource.next(
      new BfxDialogData(
        BfxDialogCommand.DIALOG_ORDER_DETAIL_FILL_WARNING_OPEN,
        null,
        event,
        warnings,
      ),
    );
  }

  doPostDetailFillWarn(selectedIds: string[], selectedItems: any[]) {
    this.doDetailFillConfirm(selectedIds, selectedItems);
  }

  doDetailFillConfirm(selectedIds: string[], selectedItems: any[]) {
    let event = {
      selectedIds: selectedIds,
      selectedItems: selectedItems,
    };

    this.orderActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_ORDER_DETAIL_FILL_CONFIRM_OPEN, null, event, null),
    );
  }

  /*****************************/
  /* ORDER RECAP */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_RECAP)
  public onOrderRecap(event: BfxBlotterActionEvent) {
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = true;
    config.data = event.selectedIds;
    config.sourceEvent = event.sourceEvent;
    config.preferredSize = { width: 800, height: 600 };

    let title: string = this.translationService.instant("order.recap.title");
    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderRecap,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  /*****************************/
  /* ORDER MODIFY */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_MODIFY)
  public onOrderModify(event: BfxBlotterActionEvent): void {
    let activeUser: ActiveUser = (
      this.contextMenuService as BfxBlotterOrdersContextMenuService
    ).getActiveUser();
    if (!this._appStatusService.isMonitorChangePanicOn() || activeUser.isTrader()) {
      this.apiService.doOrderEntryPopupForOrderId(event.selectedIds[0], OENOperationMode.MODIFY);
    } else {
      this.showPanicOnMessage();
    }
  }

  /*****************************/
  /* ORDER MODIFY INFO */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_MODIFY_INFO)
  public onOrderModifyInfo(event: BfxBlotterActionEvent): void {
    logger.out.info("DEV-TEST: onOrderModifyInfo() event: ", event);
    let activeUser: ActiveUser = (
      this.contextMenuService as BfxBlotterOrdersContextMenuService
    ).getActiveUser();
    if (!this._appStatusService.isMonitorChangePanicOn() || activeUser.isTrader()) {
      this.apiService.doOrderEntryPopupForOrderId(
        event.selectedIds[0],
        OENOperationMode.MODIFY_INFO,
      );
    } else {
      this.showPanicOnMessage();
    }
  }

  /*****************************/
  /* ORDER DUPLICATE */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_DUPLICATE)
  public onOrderDuplicate(event: BfxBlotterActionEvent): void {
    this.apiService.doOrderEntryPopupForOrderId(event.selectedIds[0], OENOperationMode.DUPLICATE);
  }

  /*****************************/
  /* VIEW AUDIT */
  // This might need to be moved out of the base abstract, as it may not be applicable to all
  @ActionListener(BfxBlotterAction.ACTION_VIEW_AUDIT)
  public onViewAudit(event: BfxBlotterActionEvent) {
    let selectedId: any = event.selectedIds[0];
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();
    config.popoutResizable = true;
    config.preferredSize = {
      width: Math.max(750, window.innerWidth / 2),
      height: 745,
    };
    config.minimumSize = { width: 630, height: 345 };

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.sourceEvent = event.sourceEvent;
    config.data = {
      orderId: selectedId,
    };

    try {
      if (event.ladderBlotter != null && event.ladderBlotter["isBenchmarkClientOrder"] != null) {
        config.data.isBenchmarkClientOrder = event.ladderBlotter["isBenchmarkClientOrder"];
        config.data.isBenchmarkAlgoOrder = event.ladderBlotter["isBenchmarkAlgoOrder"];
        config.data.isBenchmarkOrder = event.ladderBlotter["isBenchmarkOrder"];
      } else if (event.selectedItems != null && event.selectedItems.length > 0) {
        if (
          event.selectedItems[0] instanceof BmarkOrderData &&
          event.selectedItems[0].fixingDetails != null
        ) {
          config.data.isBenchmarkClientOrder =
            event.selectedItems[0].orderType == CubiqTS.OrderType.BENCHMARK &&
            event.selectedItems[0].fixingDetails.bmOrderType == CubiqTS.BenchmarkOrderType.Standard;
          config.data.isBenchmarkOrder =
            event.selectedItems[0].orderType == CubiqTS.OrderType.BENCHMARK;
          config.data.isBenchmarkAlgoOrder =
            event.selectedItems[0].orderType == CubiqTS.OrderType.BMALGO;
        }
      }
    } catch (e) {
      logger.out.error("Failed to determine benchmark order type: " + e);
    }

    let title: string;
    // Check both OrderDetail and OrderDataImpl payload types
    const isGamma: boolean =
      event.selectedItems != null &&
      event.selectedItems.length > 0 &&
      (event.selectedItems[0].isGamma || event.selectedItems[0].gammaRungId);

    // Gamma orders have strategy-related titles, everything else uses standard Order ID
    if (isGamma) {
      const strategyRef = event.selectedItems[0].strategyRef;
      title = this.translationService.instant("order.audit.gamma_title", [strategyRef]);
    } else {
      let titleId: string = selectedId;
      if (
        event.selectedItems != null &&
        event.selectedItems.length > 0 &&
        event.selectedItems[0].orderRef != null
      ) {
        titleId = event.selectedItems[0].orderRef;
      }
      title = this.translationService.instant("order.audit.title", [titleId]);
    }
    this.layoutService.launchFromDashboard(
      title,
      this.getAuditType(),
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  /* View Order Details */
  @ActionListener(BfxBlotterAction.ACTION_TRADE_VIEW_DETAILS)
  public onOrderDetailsTrades(event: BfxBlotterActionEvent) {
    this.onOrderDetails(event, true);
  }

  /*****************************/
  /* ORDER VIEW DETAILS */
  @ActionListener(BfxBlotterAction.ACTION_VIEW_DETAILS)
  public onOrderDetails(event: BfxBlotterActionEvent, openOnTrades: boolean = false) {
    let config: GLPopoutConfiguration = new GLPopoutConfiguration();
    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = false;
    config.sourceEvent = event.sourceEvent;
    config.minimumSize = DETAILS_MIN_SIZE;

    config.data = { openTradesTab: openOnTrades };
    if (event.selectedItems != null && event.selectedItems.length == 1) {
      let order = event.selectedItems[0];
      if (CubiqTS.OrderType.ALGO === order?.orderType) {
        config.data = { openTradesTab: false, openRiskTradesTab: openOnTrades };
      }
    }

    // don't persist selectedIds in config
    Object.defineProperty(config.data, "selectedIds", {
      enumerable: false,
      writable: true,
    });

    config.data.selectedIds = event.selectedIds;
    config.ladderBlotter = event.ladderBlotter;

    let title: string = this.translationService.instant("order.details.title", [
      BfxConfigIDRefHelper.getOrderRef(event.selectedItems[0]),
    ]);
    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderDetails,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  /**
   *  View entry ticket with execution monitor
   * @param event
   */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_VIEW_TICKET)
  public onOrderViewTicket(event: BfxBlotterActionEvent): void {
    logger.out.info("DEV-TEST: onOrderViewTicket() event: ", event);
    this.apiService.doOrderTicketPopup(event.selectedIds[0], OENOperationMode.MONITOR_EXECUTION);
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_ACCEPT)
  public onOrderAccept(event: BfxBlotterActionEvent) {
    let acceptanceItemState = event.itemState as BfxBlotterOrdersContextMenuItemAcceptanceState;
    let comment = "";
    let targetGroup = null;
    let callOrderRateSide = acceptanceItemState.callOrderRateSide;
    let acceptFn = () => {
      acceptanceItemState.actionRequests.accept.acceptance.forEach((ids, type) => {
        if (Array.isArray(ids) && ids.length > 0) {
          this.orderAcceptanceService.requestAcceptance(
            ids,
            comment,
            CubiqTS.AcceptanceAction.ACCEPT,
            type,
            targetGroup,
            callOrderRateSide,
            this.getOrderType(event.selectedItems),
            this.getBMOrderType(event.selectedItems),
          );
        }
      });

      acceptanceItemState.actionRequests.accept.xfer.forEach((ids, targetId) => {
        if (Array.isArray(ids) && ids.length > 0) {
          let localOrderIds: Array<string> = Object.assign(ids);
          this.orderXferService
            .requestXfer(ids, comment, CubiqTS.XferAction.ACCEPT, targetId)
            .then((response: any) => {
              this.handleAcceptanceActionFail(
                response,
                BFXNotificationSubType.ACCEPTANCE_FAIL,
                localOrderIds,
              );
            });
        }
      });
    };

    if (acceptanceItemState.warnings && acceptanceItemState.warnings.external.display) {
      let msg =
        event.selectedIds.length == 1
          ? "force.accept.order.external.single"
          : "force.accept.order.external.multi";
      let payload = {
        messages: [this.translationService.instant(msg)],
        title: "force.accept.order.title",
        callback: acceptFn,
      };

      this.orderActionDialogSource.next(
        new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_WARN_OPEN, null, null, payload),
      );
    } else {
      acceptFn();
    }
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_ACCEPT_INTO)
  public onOrderAcceptInto(event: BfxBlotterActionEvent) {
    let acceptanceItemState = event.itemState as BfxBlotterOrdersContextMenuItemAcceptanceState;
    let comment = "";

    let acceptIntoFn = () => {
      let payload = {
        requests: acceptanceItemState.actionRequests,
        activeUser: (this.contextMenuService as BfxBlotterOrdersContextMenuService).getActiveUser(),
        traderGroups: (
          this.contextMenuService as BfxBlotterOrdersContextMenuService
        ).getTraderGroups(),
      };

      this.orderActionDialogSource.next(
        new BfxDialogData(BfxDialogCommand.DIALOG_ORDER_ACCEPT_INTO_OPEN, null, event, payload),
      );
    };

    if (acceptanceItemState.warnings && acceptanceItemState.warnings.external.display) {
      let msg =
        event.selectedIds.length == 1
          ? "force.accept.order.external.single"
          : "force.accept.order.external.multi";
      let payload = {
        messages: [this.translationService.instant(msg)],
        title: "force.accept.order.title",
        callback: acceptIntoFn,
      };

      this.orderActionDialogSource.next(
        new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN, null, null, payload),
      );
    } else {
      acceptIntoFn();
    }
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_CANCEL)
  public onCancel(event: BfxBlotterActionEvent): void {
    let activeUser: ActiveUser = (
      this.contextMenuService as BfxBlotterOrdersContextMenuService
    ).getActiveUser();
    if (!this._appStatusService.isMonitorChangePanicOn() || activeUser.isTrader()) {
      let thresholdBreached: boolean =
        this.cancelWarningThreshold > 0 && event.selectedIds.length > this.cancelWarningThreshold;
      let transferItems: Array<any> = [];

      if (event.selectedIds != null && event.selectedIds.length > 0) {
        let rawDataObject: any = this.blotterOrdersService.getRawDataObject();
        let targetDeskIdColumnDef: BfxColDef =
          this.tableDefinition.getColumnDefinition(COLUMN_TARGET_DESK_ID);
        event.selectedIds.forEach((orderId: string) => {
          let item: any = rawDataObject[orderId];

          if (item != null && item[targetDeskIdColumnDef.field] != null) {
            if (item[COLUMN_XFER_TARGET_GROUP] == null) {
              let tg: CubiqTS.TradingGroupImpl = this.myTraderGroupLookup.getTraderGroup(
                item[targetDeskIdColumnDef.field],
              );

              let targetDeskName: string = "";
              if (tg) {
                targetDeskName = tg.groupCode;
              }
              let additional: any = { xferTargetGroup: targetDeskName };
              if (item != null && additional != null) {
                item = Object.assign(Object.create(item), item, additional);
              }
            }

            transferItems.push(item);
          }
        });
      }

      event["breach"] = thresholdBreached;
      event["transferItems"] = transferItems;

      if (thresholdBreached || transferItems.length > 0) {
        this.orderActionDialogSource.next(
          new BfxDialogData(BfxDialogCommand.DIALOG_ORDER_CANCEL_WARNING_OPEN, null, event, null),
        );
      } else {
        BfxOrderCancelComponentLauncher.launch(
          event.selectedItems,
          this.layoutService,
          this.translationService,
          event.sourceEvent,
        );
      }
    } else {
      this.showPanicOnMessage();
    }
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_UNLOCK)
  public onUnlock(event: BfxBlotterActionEvent): void {
    let unlockItemState = event.itemState as BfxBlotterOrdersContextMenuItemUnlockState;
    let selectedIds: Array<string> = event.selectedIds;
    if (
      !unlockItemState ||
      unlockItemState.lockType == undefined ||
      unlockItemState.lockType == null
    )
      return;
    if (unlockItemState.lockType === CubiqTS.LockType.MODIFY_LOCK) {
      this.orderDataActionService.modifyOrdersUnlock(selectedIds).then(
        () => {},
        (err) => {
          logger.out.error(
            "ERROR: BfxBlotterOrdersActionService.onUnlock(): error message: modifyOrdersUnlock failed!",
          );
        },
      );
    } else if (unlockItemState.lockType === CubiqTS.LockType.FILL_LOCK) {
      this.orderDataActionService.unlockOrdersFromFill(selectedIds).then(
        () => {},
        (err) => {
          logger.out.error(
            "ERROR: BfxBlotterOrdersActionService.onUnlock(): error message: unlockOrdersFromFill failed!",
          );
        },
      );
    } else if (unlockItemState.lockType === CubiqTS.LockType.SI_LOCK) {
      this.orderDataActionService.releaseOrder(selectedIds, null).then(
        () => {},
        (err) => {
          logger.out.error(
            "ERROR: BfxBlotterOrdersActionService.onUnlock(): error message: releaseOrder failed!",
          );
        },
      );
    } else if (unlockItemState.lockType === CubiqTS.LockType.FILL_NOW_LOCK) {
      this.orderDataActionService.fillNowUnlock(selectedIds).then(
        () => {},
        (err) => {
          logger.out.error(
            "ERROR: BfxBlotterOrdersActionService.onUnlock(): error message: fillNowUnlock failed!",
          );
        },
      );
    }
  }

  @ActionListener(BfxBlotterAction.ACTION_TRANSFER)
  public onTransfer(event: BfxBlotterActionEvent): void {
    let transferItems: Array<any> = [];

    if (event.selectedIds != null && event.selectedIds.length > 0) {
      let rawDataObject: any = this.blotterOrdersService.getRawDataObject();
      let targetDeskIdColumnDef: BfxColDef =
        this.tableDefinition.getColumnDefinition(COLUMN_TARGET_DESK_ID);
      event.selectedIds.forEach((orderId: string) => {
        let item: any = rawDataObject[orderId];

        if (item != null && item[targetDeskIdColumnDef.field] != null) {
          transferItems.push(item);
        }
      });
    }

    event["transferItems"] = transferItems;

    let title: string = this.translationService.instant("transfer.order.title");

    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = true;
    config.preferredSize = {
      width: Math.max(750, window.innerWidth / 2),
      height: 389,
    };
    config.minimumSize = { width: 630, height: 389 };
    config.data = event.selectedIds;
    config.sourceEvent = event.sourceEvent;
    config.errorDialogOnMultiple = true;

    this.populateTakeTransferOrderType(event, config);

    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderTransfer,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_TAKE)
  public onTake(event: BfxBlotterActionEvent): void {
    let transferItems: Array<any> = [];

    if (event.selectedIds != null && event.selectedIds.length > 0) {
      let rawDataObject: any = this.blotterOrdersService.getRawDataObject();
      let targetDeskIdColumnDef: BfxColDef =
        this.tableDefinition.getColumnDefinition(COLUMN_TARGET_DESK_ID);
      event.selectedIds.forEach((orderId: string) => {
        let item: any = rawDataObject[orderId];

        if (item != null && item[targetDeskIdColumnDef.field] != null) {
          transferItems.push(item);
        }
      });
    }

    event["transferItems"] = transferItems;

    let title: string = this.translationService.instant("take.order.title");

    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = true;
    config.preferredSize = {
      width: Math.max(750, window.innerWidth / 2),
      height: 389,
    };
    config.minimumSize = { width: 630, height: 389 };
    config.data = event.selectedIds;
    config.sourceEvent = event.sourceEvent;
    config.errorDialogOnMultiple = true;

    this.populateTakeTransferOrderType(event, config);

    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderTake,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_FORCE_TAKE)
  public onForceTake(event: BfxBlotterActionEvent): void {
    let transferItems: Array<any> = [];

    if (event.selectedIds != null && event.selectedIds.length > 0) {
      let rawDataObject: any = this.blotterOrdersService.getRawDataObject();
      let targetDeskIdColumnDef: BfxColDef =
        this.tableDefinition.getColumnDefinition(COLUMN_TARGET_DESK_ID);
      event.selectedIds.forEach((orderId: string) => {
        let item: any = rawDataObject[orderId];

        if (item != null && item[targetDeskIdColumnDef.field] != null) {
          transferItems.push(item);
        }
      });
    }

    event["transferItems"] = transferItems;

    let config: GLPopoutConfiguration = new GLPopoutConfiguration();

    config.initialState = GLPopoutState.POPOUT;
    config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
    config.popoutResizable = true;
    config.preferredSize = {
      width: Math.max(750, window.innerWidth / 2),
      height: 389,
    };
    config.minimumSize = { width: 630, height: 389 };
    config.data = event.selectedIds;
    config.sourceEvent = event.sourceEvent;
    config.errorDialogOnMultiple = true;

    this.populateTakeTransferOrderType(event, config, false);

    let msg: string =
      event.selectedIds.length == 1
        ? "force.take.order.external.single"
        : "force.take.order.external.multi";
    let payload: any = {
      messages: [this.translationService.instant(msg)],
      title: "force.take.order.external.title",
      callback: this.confirmForceTake.bind(this, config),
    };
    this.orderActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_ORDER_CANCEL_CONFIRM_OPEN, null, null, payload),
    );
  }

  public confirmForceTake(config: GLPopoutConfiguration): void {
    let title: string = this.translationService.instant("force.take.order.title");
    this.layoutService.launchFromDashboard(
      title,
      DashboardItemType.OrderForceTake,
      true,
      GoldenLayoutAdditionMode.DEFAULT,
      config,
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_ABORT_TRANSFER)
  public onTransferAbort(event: BfxBlotterActionEvent): void {
    let ids: Array<string> = event.selectedIds;

    if (ids != null && ids.length > 0) {
      let rawDataObject: any = this.blotterOrdersService.getRawDataObject();
      let targetDeskIdKey: string =
        this.tableDefinition.getColumnDefinition(COLUMN_TARGET_DESK_ID).field;
      // let targetDeskNameFunc: Function= this.tableDefinition.getColumnDefinition(COLUMN_TARGET_DESK_ID).valueGetter;

      let targetDeskId: CubiqTS.Long = rawDataObject[ids[0]][targetDeskIdKey];
      let tg: CubiqTS.TradingGroupImpl = this.myTraderGroupLookup.getTraderGroup(targetDeskId);

      let targetDeskName: string = "";
      if (tg) {
        targetDeskName = tg.groupCode;
      }
      let allSameTarget: boolean = ids.every(
        (id: string) => rawDataObject[id][targetDeskIdKey] == targetDeskId,
      );

      let message: string =
        ids.length == 1
          ? "order.transfer.abort.single"
          : allSameTarget
          ? "order.transfer.abort.multi.same"
          : "order.transfer.abort.multi.different";
      message = this.translationService.instant(message, {
        deskId: targetDeskName,
      });
      const messages = [message];

      // We permit aborting of orders in transfer to or from external groups (with EXTERNAL_ABORT role)
      const rows = this.blotterOrdersService.getRowDataForIdList(ids);
      const externalOrders = rows.filter((order) => {
        const srcTraderGroup = this.myTraderGroupLookup.getTraderGroup(order.deskId);
        const targetTraderGroup = this.myTraderGroupLookup.getTraderGroup(order.targetDeskId);
        return (
          srcTraderGroup &&
          targetTraderGroup &&
          (srcTraderGroup.isExternallyFilledFg || targetTraderGroup.isExternallyFilledFg)
        );
      });
      if (externalOrders.length > 0) {
        // WE have at least some external orders so we add a warning message to the list
        const msgId =
          externalOrders.length == 1
            ? "order.transfer.abort.external.single"
            : "order.transfer.abort.external.multi";
        message = this.translationService.instant(msgId, [externalOrders.length]);
        messages.push(message);
      }

      let subMessage: string = this.translationService.instant("order.transfer.abort.submessage");

      let payload: any = {
        title: "orders.transfer.abort.title",
        messages: messages,
        subMessage: subMessage,
        callback: this.executeTransferAbort.bind(this),
      };
      this.orderActionDialogSource.next(
        new BfxDialogData(
          BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN,
          null,
          event,
          payload,
          event.body,
        ),
      );
    }
  }

  public executeTransferAbort(event: BfxBlotterActionEvent): void {
    let localOrderIds: Array<string> = Object.assign(event.selectedIds);
    this.orderXferService
      .requestXfer(event.selectedIds, null, CubiqTS.XferAction.CANCEL, "0")
      .then((response: any) => {
        this.handleAcceptanceActionFail(response, BFXNotificationSubType.ABORT_FAIL, localOrderIds);
      });
  }

  public executeAcceptInto(
    event: BfxBlotterActionEvent,
    groupId: CubiqTS.Long,
    comment: string,
    callOrderRateSide: CubiqTS.RateSideType = null,
  ) {
    let acceptanceItemState = event.itemState as BfxBlotterOrdersContextMenuItemAcceptanceState;

    acceptanceItemState.actionRequests.acceptInto.acceptance.forEach((ids, type) => {
      if (Array.isArray(ids) && ids.length > 0) {
        logger.out.info(CubiqTS.AcceptanceType[type]);
        this.orderAcceptanceService.requestAcceptance(
          ids,
          comment,
          CubiqTS.AcceptanceAction.ACCEPT,
          type,
          groupId.toString(),
          callOrderRateSide,
        );
      }
    });

    acceptanceItemState.actionRequests.acceptInto.xfer.forEach((ids) => {
      if (Array.isArray(ids) && ids.length > 0) {
        let localOrderIds: Array<string> = Object.assign(ids);
        this.orderXferService
          .requestXfer(ids, comment, CubiqTS.XferAction.ACCEPT, groupId.toString())
          .then((response: any) => {
            this.handleAcceptanceActionFail(
              response,
              BFXNotificationSubType.ACCEPTANCE_FAIL,
              localOrderIds,
            );
          });
      }
    });
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_REJECT)
  public onOrderReject(event: BfxBlotterActionEvent) {
    let rejectItemState = event.itemState as BfxBlotterOrdersContextMenuItemRejectState;
    let comment = "";

    let rejectFn = () => {
      rejectItemState.actionRequests.reject.acceptance.forEach((ids, type) => {
        if (Array.isArray(ids) && ids.length > 0) {
          logger.out.info(CubiqTS.AcceptanceType[type]);
          this.orderAcceptanceService.requestAcceptance(
            ids,
            comment,
            CubiqTS.AcceptanceAction.REJECT,
            type,
            null,
            null,
            this.getOrderType(event.selectedItems),
            this.getBMOrderType(event.selectedItems),
          );
        }
      });

      rejectItemState.actionRequests.reject.xfer.forEach((ids, targetId) => {
        if (Array.isArray(ids) && ids.length > 0) {
          let localOrderIds: Array<string> = Object.assign(ids);
          this.orderXferService
            .requestXfer(ids, comment, CubiqTS.XferAction.REJECT, targetId)
            .then((response: any) => {
              this.handleAcceptanceActionFail(
                response,
                BFXNotificationSubType.REJECTIONS_FAIL,
                localOrderIds,
              );
            });
        }
      });
    };

    if (rejectItemState.warnings && rejectItemState.warnings.external.display) {
      let msg =
        event.selectedIds.length == 1
          ? "force.reject.order.external.single"
          : "force.reject.order.external.multi";
      let payload = {
        messages: [this.translationService.instant(msg)],
        title: "force.reject.order.title",
        callback: rejectFn,
      };

      this.orderActionDialogSource.next(
        new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_CONFIRM_OPEN, null, null, payload),
      );
    } else {
      rejectFn();
    }
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_ABORT)
  public onOrderAbort(event: BfxBlotterActionEvent) {
    let items = event?.selectedItems;

    if (items != null && event.selectedItems.length > 0) {
      let acceptanceType: CubiqTS.AcceptanceType =
        items[0].orderState === CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED
          ? CubiqTS.AcceptanceType.MODIFICATION
          : CubiqTS.AcceptanceType.ENTRY;

      this.orderAcceptanceService.requestAcceptance(
        [items[0].orderId.toString()],
        "",
        CubiqTS.AcceptanceAction.ABORT,
        acceptanceType,
        null,
        null,
        items[0].orderType,
      );
    }
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_REACTIVATE)
  public onOrderReactivate(event: BfxBlotterActionEvent) {
    let selectedIds: Array<string> = event.selectedIds;
    this.orderDataActionService.reactivateOrders(selectedIds);
  }

  // @ActionListener(BfxBlotterAction.ACTION_ORDER_REACTIVATE)
  // public onOrderUnlockFromFill(event: BfxBlotterActionEvent) {
  //     let selectedIds: Array<string> = event.selectedIds;
  //     this.orderDataActionService.unlockOrdersFromFill(selectedIds)

  // }

  /**
   * Checkes if a trader wants to fill a certain number of
   * orders that breaches a system configured limit
   * @param _event the fill event, either quickfill or detail fill
   */
  protected checkFillWarning(
    selectedIds: Array<string>,
    selectedItems: Array<any>,
    warnings: any,
  ): any {
    let result: boolean = false;

    let activeUser: ActiveUser = (
      this.contextMenuService as BfxBlotterOrdersContextMenuService
    ).getActiveUser();

    if (
      this.fillWarningThreshold > 0 &&
      selectedIds.length > this.fillWarningThreshold &&
      activeUser.userTypeId == UserType.TRADER
    ) {
      warnings.fill.display = true;
      warnings.fill.ids = selectedIds.concat();
      warnings.fill.orderRefs = Array.isArray(selectedItems)
        ? selectedItems.map((item) => BfxConfigIDRefHelper.getOrderRef(item))
        : [];
      warnings.show = true;
    }

    return warnings;
  }

  private showPanicOnMessage() {
    let payload = {
      messages: [this.translationService.instant("orderbook.changes.onpanic.message")],
      title: "fxoms.general.message.title",
      callback: () => {},
      callbackNegative: () => {},
    };
    this.orderActionDialogSource.next(
      new BfxDialogData(BfxDialogCommand.DIALOG_GENERIC_OK, null, null, payload),
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_PAUSE)
  public onPause(event: BfxBlotterActionEvent): void {
    // TODO not sure what these do/did? (unref in BfxOrderCancelComponent -dc)
    event["breach"] = false;
    event["transferItems"] = [];

    let instructions: Array<OrderPauseResumeInstruction> = this.buildPauseResumeInstructions(
      event.selectedItems,
    );

    BfxOrderPauseResumeComponentLauncher.launch(
      BfxBlotterAction.ACTION_ORDER_PAUSE,
      instructions,
      this.layoutService,
      this.translationService,
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_RESUME)
  public onResume(event: BfxBlotterActionEvent): void {
    // TODO not sure what these do/did? (unref in BfxOrderCancelComponent -dc)
    event["breach"] = false;
    event["transferItems"] = [];

    let instructions: Array<OrderPauseResumeInstruction> = this.buildPauseResumeInstructions(
      event.selectedItems,
    );

    BfxOrderPauseResumeComponentLauncher.launch(
      BfxBlotterAction.ACTION_ORDER_RESUME,
      instructions,
      this.layoutService,
      this.translationService,
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_ENABLE_INFLIGHT)
  public onInflightCheckEnable(event: BfxBlotterActionEvent): void {
    let orderIds: CubiqTS.Long[] = event.selectedItems
      .filter(
        (order: CubiqTS.OrderDataImpl) =>
          (order.orderType === CubiqTS.OrderType.ALGO ||
            order.orderType === CubiqTS.OrderType.BMALGO) &&
          order.inflightInclusionState === CubiqTS.InflightInclusionState.DISABLED,
      )
      .map((o) => o.orderId);
    this.orderDataActionService.toggleInflightInclusionState(
      orderIds,
      CubiqTS.InflightInclusionState.ENABLED,
    );
  }

  @ActionListener(BfxBlotterAction.ACTION_ORDER_DISABLE_INFLIGHT)
  public onInflightCheckDisable(event: BfxBlotterActionEvent): void {
    let orderIds: CubiqTS.Long[] = event.selectedItems
      .filter(
        (order: CubiqTS.OrderDataImpl) =>
          (order.orderType === CubiqTS.OrderType.ALGO ||
            order.orderType === CubiqTS.OrderType.BMALGO) &&
          order.inflightInclusionState === CubiqTS.InflightInclusionState.ENABLED,
      )
      .map((o) => o.orderId);
    this.orderDataActionService.toggleInflightInclusionState(
      orderIds,
      CubiqTS.InflightInclusionState.DISABLED,
    );
  }

  /* FILL_APPROVE */
  @ActionListener(BfxBlotterAction.ACTION_DI_FILL_APPROVE)
  public onFillApprove(event: BfxBlotterActionEvent) {
    if (Array.isArray(event.selectedIds) && event.selectedIds.length > 0) {
      this.salesApprovalPromiseService.requestApproval(
        event.selectedIds,
        "",
        CubiqTS.SalesApprovalAction.APPROVE_FILL,
      );
    }
  }

  /* FILL_CANCEL */
  @ActionListener(BfxBlotterAction.ACTION_DI_FILL_CANCEL)
  public onFillCancel(event: BfxBlotterActionEvent) {
    if (Array.isArray(event.selectedIds) && event.selectedIds.length > 0) {
      this.salesApprovalPromiseService.requestApproval(
        event.selectedIds,
        "",
        CubiqTS.SalesApprovalAction.CANCEL_FILL,
      );
    }
  }

  /* CLEAR_FILL */
  @ActionListener(BfxBlotterAction.ACTION_DI_FILL_CLEAR)
  public onFillClear(event: BfxBlotterActionEvent) {
    if (Array.isArray(event.selectedIds) && event.selectedIds.length > 0) {
      this.salesApprovalPromiseService.requestApproval(
        event.selectedIds,
        "",
        CubiqTS.SalesApprovalAction.CLEAR_FILL,
      );
    }
  }

  /* Fill Now */
  @ActionListener(BfxBlotterAction.ACTION_ORDER_FILL_NOW)
  public onFillNow(event: BfxBlotterActionEvent) {
    if (Array.isArray(event.selectedItems) && event.selectedItems.length) {
      const order = event.selectedItems[0] as CubiqTS.OrderData;
      let config: GLPopoutConfiguration = new GLPopoutConfiguration();

      config.initialState = GLPopoutState.POPOUT;
      config.undockBehaviour = GLPopoutUndockBehaviour.APPLY_BOUNDING_SIZE;
      config.popoutResizable = false;
      config.preferredSize = {
        width: 500,
        height: 280,
      };
      config.minimumSize = { width: 500, height: 280 };
      config.data = { order };

      config.sourceEvent = event.sourceEvent;

      let title: string = this.translationService.instant("fill_now.dialog.title", [
        order.orderRef,
      ]);
      this.layoutService.launchFromDashboard(
        title,
        DashboardItemType.OrderFillNow,
        false,
        GoldenLayoutAdditionMode.DEFAULT,
        config,
      );
    }
  }

  /**
   * Process an error for the specified action event
   * @param event
   * @param response
   */
  private notifyActionError(event: BfxBlotterActionEvent, response: any) {
    let errorMessage: string;
    if (response instanceof CubiqTS.ErrorsImpl) {
      errorMessage = this.errorsHandler.getErrorMessages(response).join(",");
    } else {
      errorMessage = response?.toString() ?? "<Unknown Error>";
    }
    let payload = {
      messages: [
        this.translationService.instant("blotter.action.generic_error.desc", [errorMessage]),
      ],
      title: "blotter.action.generic_error.title",
      showConfirmationMessage: false,
      showLogoutMessage: false,
      intent: BFXDialogIntent.NEGATIVE,
    };

    const dialogData = new BfxDialogData(
      BfxDialogCommand.DIALOG_GENERIC_OK,
      null,
      null,
      payload,
      event.body,
    );
    this.orderActionDialogSource.next(dialogData);
  }

  buildPauseResumeInstructions(candidates: Array<LimitOrder>): Array<OrderPauseResumeInstruction> {
    let instructions: Array<OrderPauseResumeInstruction> = new Array<OrderPauseResumeInstruction>();

    candidates.map((order) => {
      let instruction: OrderPauseResumeInstruction = new OrderPauseResumeInstruction();
      instruction.order = order;

      instructions.push(instruction);
    });

    return instructions;
  }

  private handleAcceptanceActionFail(
    responses: any,
    notificationSubType: BFXNotificationSubType,
    fallbackLocalIds: Array<string>,
  ): void {
    // Acceptance always returns an array of results, one for each batch operation
    if (Array.isArray(responses)) {
      for (const response of responses) {
        if (response instanceof CubiqTS.ErrorsImpl) {
          // only send a notification on errors
          if (
            ((response as any).orderIds == null ||
              (Array.isArray((response as any).orderIds) &&
                (response as any).orderIds.length === 0)) &&
            Array.isArray(fallbackLocalIds) &&
            fallbackLocalIds.length > 0
          ) {
            (response as any).orderIds = fallbackLocalIds;
          }
          this.notifService.handleErrors(
            response,
            BFXNotificationType.ORDER_ACTION_FAIL,
            notificationSubType,
          );
        }
      }
    }
  }

  protected populateTakeTransferOrderType(
    event: BfxBlotterActionEvent,
    config: GLPopoutConfiguration,
    populateBenchmarks: boolean = true,
  ): void {
    if (
      populateBenchmarks &&
      event.selectedItems != null &&
      event.selectedItems.find(
        (item: CubiqTS.OrderDataImpl) => item.orderType != CubiqTS.OrderType.BENCHMARK,
      ) == null
    ) {
      config.data = event.selectedItems;
      Object.defineProperty(config.data, "benchmarks", {
        value: true,
        enumerable: false,
      });
    } else if (
      event.selectedItems != null &&
      event.selectedItems.find(
        (item: CubiqTS.OrderDataImpl) => item.orderType != CubiqTS.OrderType.ALGO,
      ) == null
    ) {
      config.data = event.selectedItems;
      Object.defineProperty(config.data, "algos", {
        value: true,
        enumerable: false,
      });
    }
  }

  /**
   * Check if all items in the order list have the same order type.
   * Only checks for benchmark and BM algo order types, as these need to be populated
   * in acceptance requests
   *
   * @param items list of orders
   * @returns BENCHMARK if all orders in the list have the benchmark type, BMALGO if
   * all orders in the list are benchmark algos, null otherwise
   */
  protected getOrderType(items: CubiqTS.OrderDataImpl[]): CubiqTS.OrderType {
    let orderType: CubiqTS.OrderType = null;

    if (items != null && Array.isArray(items)) {
      if (items.every((item) => item?.orderType == CubiqTS.OrderType.BENCHMARK)) {
        orderType = CubiqTS.OrderType.BENCHMARK;
      } else if (items.every((item) => item?.orderType == CubiqTS.OrderType.BMALGO)) {
        orderType = CubiqTS.OrderType.BMALGO;
      }
    }

    return orderType;
  }

  /**
   * Check if all items in the order list have the same benchmark order type
   * and that order type is PositionOrder.
   *
   * @param items list of orders
   * @returns PositionOrder if all orders in the list have that benchmark order type,
   * otherwise returns null
   */
  private getBMOrderType(items: CubiqTS.OrderDataImpl[]): CubiqTS.BenchmarkOrderType {
    let bmOrderType: CubiqTS.BenchmarkOrderType = null;

    if (items != null && Array.isArray(items)) {
      if (items.every((item) => item?.orderType == CubiqTS.OrderType.BENCHMARK)) {
        if (
          items.every(
            (item) => item?.fixingDetails?.bmOrderType == CubiqTS.BenchmarkOrderType.PositionOrder,
          )
        ) {
          bmOrderType = CubiqTS.BenchmarkOrderType.PositionOrder;
        }
      }
    }

    return bmOrderType;
  }
}

function doNoMidRungError() {
  // TODO : do we load all rungs into detail fill?
  throw new Error("Unable to determine MID rung for filling");
}
